import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Supplier } from "../models/supplier.model";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api/";

// console.log(BASE_URL);

const safeWh = (wh: any) => (wh && wh !== "undefined" && wh !== "null" ? wh : "allWh");

export const SupplierApi = createApi({
  reducerPath: "SupplierApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["Supplier"],
  endpoints: (builder) => ({
    Suppliers: builder.query<Supplier[], void>({
      query: () => "/supplier",
      providesTags: ["Supplier"],
    }),
    SupplierAllDetails: builder.query<Supplier[], any>({
      query: ({ aamarId, id }) => `/supplier/all/details/${aamarId}/${id}`,
      providesTags: ["Supplier"],
    }),
    Suppliersall: builder.query<Supplier[], any>({
      query: ({ aamarId }) => `/supplier/all/${aamarId}`,
      providesTags: ["Supplier"],
    }),
    SupplierExport: builder.query<Supplier[], any>({
      query: ({ warehouse, aamarId }) =>
        `/supplier/export/${safeWh(warehouse)}/${aamarId}`,
      providesTags: ["Supplier"],
    }),

    Supplier: builder.query<Supplier, string>({
      query: (_id) => `/supplier/${_id}`,
      providesTags: ["Supplier"],
    }),
    supplierList: builder.query<Supplier[], any>({
      query: (aamarId) => `/supplier/list/${aamarId}`,
      providesTags: ["Supplier"],
    }),
    SupplierTest: builder.query<Supplier, string>({
      query: (_id) => `/supplier/test/${_id}`,
      providesTags: ["Supplier"],
    }),
    SupplierPurchase: builder.query<Supplier, string>({
      query: (_id) => `/supplier/purchase/${_id}`,
      providesTags: ["Supplier"],
    }),
    SupplierByProduct: builder.query<Supplier, any>({
      query: ({ code, aamarId }) => `/supplier/product/${aamarId}/${code}`,
      providesTags: ["Supplier"],
    }),
    addImportSupplier: builder.mutation<{}, Supplier>({
      query: (Supplier) => ({
        url: "/supplier/import",
        method: "POST",
        body: Supplier,
      }),
      invalidatesTags: ["Supplier"],
    }),
    addSupplier: builder.mutation<{}, Supplier>({
      query: (supplier) => ({
        url: "/supplier",
        method: "POST",
        body: supplier,
      }),
      invalidatesTags: ["Supplier"],
    }),
    updateSupplier: builder.mutation<{}, Supplier>({
      query: ({ _id, ...rest }) => ({
        url: `/supplier/${_id}`,
        method: "PUT",
        body: rest,
      }),
      invalidatesTags: ["Supplier"],
    }),

    countSupplier: builder.query<Supplier[], void>({
      query: () => "/supplier/count",
      providesTags: ["Supplier"],
    }),

    supplierPagenation: builder.query<Supplier, any>({
      query: ({ page, size, aamarId, q }) =>
        `/supplier/${page}/${size}/${aamarId}?q=${q}`, // not found
      // query: ({page, size, q}) => `/Customer`,
      providesTags: ["Supplier"],
    }),

    supplierLedger: builder.query<Supplier, any>({
      query: (_id) => `/supplier/ledger/${_id}`,
      providesTags: ["Supplier"],
    }),
    supplierLedgerByDate: builder.query<
      any,
      { id: string; start: string; end: string }
    >({
      query: ({ id, start, end }) =>
        `/supplier/ledgerByDate/${id}/${start}/${end}`,
      providesTags: ["Supplier"],
    }),

    deleteSupplier: builder.mutation<void, string>({
      query: (id) => ({
        url: `/supplier/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Supplier"],
    }),
  }),
});

export const {
  useSuppliersQuery,
  useSupplierAllDetailsQuery,
  useSuppliersallQuery,
  useSupplierQuery,
  useSupplierTestQuery,
  useSupplierPurchaseQuery,
  useSupplierExportQuery,
  useSupplierByProductQuery,
  useSupplierPagenationQuery,
  useSupplierLedgerQuery,
  useSupplierLedgerByDateQuery,
  useCountSupplierQuery,
  useAddImportSupplierMutation,
  useSupplierListQuery,
  useAddSupplierMutation,
  useUpdateSupplierMutation,
  useDeleteSupplierMutation,
} = SupplierApi;

export default SupplierApi;
